<template>
  <span :class="['badge', outcomeClass, 'rounded-pill', 'px-4', 'py-2']">{{ outcomeText }}</span>
</template>

<script>
export default {
  props: {
    outcome: {
      type: String,
      default: null,
    },
  },
  computed: {
    outcomeClass() {
      return this.outcome ? 'badge-outcome-' + this.outcome.toLowerCase() : 'badge-outcome-empty'
    },
    outcomeText() {
      return this.outcome
        ? this.$t('efficiencyTestsList.efficiencyTestsListTable.outcomeOptions.' + this.outcome)
        : '-'
    },
  },
}
</script>

<style lang="scss" scoped>
.badge-outcome-fail {
  font-size: 12px;
  background: rgb(252, 234, 229);
  color: rgb(192, 67, 42);
  border: 1px solid rgb(242, 193, 179);
}
.badge-outcome-pass {
  font-size: 12px;
  background: rgb(233, 245, 233);
  color: rgb(53, 121, 53);
  border: 1px solid rgb(188, 223, 188);
}
.badge-outcome-empty {
  font-size: 12px;
  background: rgb(241, 243, 245);
  color: rgb(173, 181, 189);
  border: 1px solid rgb(227, 230, 233);
  width: 100%;
}
</style>
